import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsPersonLock } from "react-icons/bs";
import profileDefault from "../../assets/images/user.png";

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import { FaEyeSlash, FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import axiosClient from "../../axios-client";
import { FiEdit2, FiLock } from "react-icons/fi";
import { TbArrowBackUp } from "react-icons/tb";

function EditProfile() {
    const { user, profileId } = useContext(AuthContext);

    const [profilePic, setProfilePic] = useState("");
    const [newProfielPicURL, setNewProfielPicURL] = useState("");
    const [newProfielPic, setNewProfielPic] = useState("");
    const [isUserNameChanged, setIsUserNameChanged] = useState(false);
    const [userName, setUserName] = useState("");
    const [isMyListUpdated, setisMyListUpdated] = useState(false);
    const [profile, setProfile] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [error, setError] = useState(null);
    const location = useLocation()
    const [filters, setFilters] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await axiosClient.get(`/profiles/${location.state.profileId}/`); // Replace with your API endpoint
                setProfile(response.data);
                setFilters(response.data.filters);
            } catch (err) {
                // console.error(err);
                setError("Failed to fetch profiles.");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);


    const inputRef = useRef(null);

    const handleFileChange = (event) => {
        const fileObj = event.target.files[0];
        setNewProfielPic(fileObj);
        setNewProfielPicURL(URL.createObjectURL(fileObj));
    };

    const toggleFilter = (filter) => {
        setFilters((prev) => ({ ...prev, [filter]: !prev[filter] }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoadingData(true)
        try {
            // Create FormData
            const formData = new FormData();
            formData.append("username", userName || profile.username);
            formData.append("filters", JSON.stringify(filters));
            if (newProfielPic) {
                const originalFileName = newProfielPic.name;
                const fileExtension = originalFileName.split('.').pop();
                const newFileName = `${originalFileName.replace(`.${fileExtension}`, '')}_${user.id}_${Date.now()}.${fileExtension}`;
                const renamedAvatar = new File([newProfielPic], newFileName, { type: newProfielPic.type });
    
                formData.append("avatar", renamedAvatar);
            }

            // Make the API request to update the profile
            const response = await axiosClient.put(
                `/profiles/update/${profile.id}/`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            // update()
            toast.success("Profil mis à jour avec succès", {
                position: "top-right",
                autoClose: 1500,
            });
            setLoadingData(false)
            setTimeout(() => {
                window.location.reload();
            }, 1500);

        } catch (err) {
            // console.error("Error updating profile", err);
            setError("Failed to update profile.");
            setLoadingData(false)
        }
    };
    const handleDeleteProfile = async () => {
        setLoading(true); // Start loading
        try {
            // Verify the password before deleting
            const verifyResponse = await axiosClient.post("verify-password/", {
                user_id: user.id,
                password,
            });


            // If password is correct, proceed to delete profile
            await axiosClient.delete(`/profiles/delete/${profile.id}/`);
            toast.success("Profil supprimé avec succès.", {
                position: "top-right",
                autoClose: 3000,
            });
            navigate("/profile"); // Redirect to the homepage
        } catch (err) {
            // Check if it's a password error from the server (400 status)
            if (err.response && err.response.status === 400) {
                toast.error("Mot de passe incorrect.", {
                    position: "top-right",
                    autoClose: 3000,
                });
            } else {
                // Handle other errors
                // console.error("Erreur lors de la suppression du profil", err);
                toast.error("Impossible de supprimer le profil.", {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
        } finally {
            setLoading(false); // Stop loading
            setShowModal(false); // Hide modal
        }
    };


    return (
        <section
            className="py-10 px-3 min-h-[100vh] flex-col flex items-center justify-center relative"  // Ensures the section takes the full height and centers content
            style={{
                background: `url(${WelcomePageBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
            }}
        >
            <ToastContainer />
            <Link
                onClick={() => navigate(-1)}
                className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                title="Se déconnecter"
            >
                <TbArrowBackUp size={"26px"} className="text-orange-500" />
            </Link>
            <div className="pb-5 flex justify-center items-center ">
                <img
                    className="h-10 cursor-pointer w-18"
                    src={logo}
                    alt="NETFLIX"
                />
            </div>
            <div className="relative w-full bg-white/5 max-w-sm backdrop-blur-md p-5 md:p-10 rounded-lg">
                {/* <Link
                    to={"/edit-profile-password"}
                    className="absolute top-2 right-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                    title="Modifier le mot de passe"
                >
                    <BsPersonLock size={"22px"} className="text-orange-500" />
                </Link> */}

                <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
                    Modifier votre profil
                </h1>

                <div className="flex flex-col gap-5 justify-between items-center cursor-pointer mb-4 md:mb-8">
                    <div className="relative">

                        {newProfielPicURL || profile?.avatar ? (
                            <img
                                className="border-2 border-orange-400 w-24 h-24 rounded-full cursor-pointer"
                                src={(newProfielPicURL || profile?.avatar)}
                                alt="Profile"
                            />
                        ) : (
                            <img
                                className="border-2 border-orange-400 w-24 h-24 rounded-full cursor-pointer"
                                src={profileDefault}
                                alt="Profile"
                            />
                        )}

                        <input
                            type="file"
                            ref={inputRef}
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        <div className="absolute top-1 right-0 bg-white rounded-full p-1">
                            <FiEdit2 onClick={() => inputRef.current.click()} className="text-orange-500 cursor-pointer" />
                        </div>

                    </div>

                    <input
                        type="text"
                        name="nom"
                        id="nom"
                        className="bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg w-full focus:ring-primary-600 focus:border-primary-600 block p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                        placeholder="Nom complet"
                        defaultValue={profile?.username}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                </div>
                <div className="flex flex-col gap-1 justify-start items-start cursor-pointer">
                    <h4 className="text-center text-md text-white mb-2">Vos filtres :</h4>
                    {Object.entries(filters).map(([label, isActive]) => (
                        <div
                            key={label}
                            className="flex justify-between items-center w-full max-w-sm gap-10 cursor-pointer"
                            onClick={() => toggleFilter(label)}
                        >
                            <span
                                className={`text-md font-semibold ${isActive ? "line-through text-gray-400" : "text-white"}`}
                            >
                                {label}
                            </span>
                            {label === "VULGARITÉ SONORE" ? (
                                isActive ? (
                                    <FaMicrophoneSlash className="h-5 w-5 text-gray-400" />
                                ) : (
                                    <FaMicrophone className="h-5 w-5 text-white" />
                                )
                            ) : isActive ? (
                                <FaEyeSlash className="h-5 w-5 text-gray-400" />
                            ) : (
                                <FaEye className="h-5 w-5 text-white" />
                            )}
                        </div>
                    ))}
                </div>
                <Link
                    to={"/edit-profile-password"}
                    className="mt-5 gap-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                    title="Modifier le mot de passe"
                >
                    <BsPersonLock size={"22px"} className="text-orange-500" />
                    <h4 className="font-medium cursor-pointer hover:underline text-center text-md text-gray-300">
                        {profile?.password ? "Modifier votre mot de passe" : "Ajouter un mot de passe"}
                    </h4>
                </Link>
                    


            </div>
            <div className="w-[100%] mt-3 flex items-center justify-center">
                <Link >
                    <button disabled={loadingData} onClick={handleSubmit} style={{
                        background: "linear-gradient(to right, #2ea7a9, #72c9cb)",
                    }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md   md:text-md flex items-center justify-center ">
                        {loadingData ? "Enregistrement..." : "Enregistrer le profil"}
                    </button>

                </Link>
            </div>
            <div className="w-[100%] mt-1 flex items-center justify-center">
                <Link >
                    <button onClick={() => setShowModal(true)} style={{
                        background: "linear-gradient(to right, #ff2828, #ff5959)",
                    }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md   md:text-md flex items-center justify-center ">
                        Supprimer le profil
                    </button>

                </Link>
            </div>
            {/* Custom Modal */}
            {showModal && (
                <div
                    id="medium-modal"
                    tabIndex="-1"
                    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
                >
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                        {/* Modal header */}
                        <h2 className="text-lg font-semibold mb-4">Entrer le mot de passe de compte</h2>

                        {/* Modal body */}
                        <p className="text-sm text-gray-500 mb-4">
                            Veuillez entrer votre mot de passe pour confirmer la suppression de ce profil.
                        </p>
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
                        />

                        {/* Modal footer */}
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={() => setShowModal(false)} // Close modal
                                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={handleDeleteProfile} // Handle delete
                                className={`px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 ${loading ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                disabled={!password.trim() || loading} // Disable button if no password or loading
                            >
                                {loading ? "Suppression..." : "Supprimer"}
                            </button>
                        </div>
                    </div>
                </div>

            )}
        </section>
    );
}

export default EditProfile;
